type IconProps = {
  color?: string
  size?: number
}

export const CheckOutline = ({ size }: IconProps) => {
  return (
    <svg
      width={size || 20}
      height={size || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33458 12.6433L15.9946 4.98242L17.1738 6.16076L8.33458 14.9999L3.03125 9.69659L4.20958 8.51826L8.33458 12.6433Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const EditorTextSize = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33464 5.00065V17.5007H6.66797V5.00065H1.66797V3.33398H13.3346V5.00065H8.33464ZM15.0013 11.6673V17.5007H13.3346V11.6673H10.8346V10.0007H17.5013V11.6673H15.0013Z"
        fill={color || '#666666'}
      />
    </svg>
  )
}

export const EditorTextBold = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 9.16732H10.4167C10.9692 9.16732 11.4991 8.94782 11.8898 8.55712C12.2805 8.16642 12.5 7.63652 12.5 7.08398C12.5 6.53145 12.2805 6.00155 11.8898 5.61085C11.4991 5.22014 10.9692 5.00065 10.4167 5.00065H6.66667V9.16732ZM15 12.9173C15 13.4098 14.903 13.8974 14.7145 14.3524C14.5261 14.8074 14.2499 15.2207 13.9016 15.569C13.5534 15.9172 13.14 16.1934 12.6851 16.3819C12.2301 16.5703 11.7425 16.6673 11.25 16.6673H5V3.33398H10.4167C11.1508 3.33402 11.8688 3.54953 12.4816 3.9538C13.0944 4.35807 13.575 4.93332 13.8639 5.60821C14.1528 6.2831 14.2373 7.02795 14.1068 7.7504C13.9764 8.47284 13.6367 9.1411 13.13 9.67232C13.6989 10.0017 14.1711 10.475 14.4993 11.0445C14.8276 11.6141 15.0002 12.26 15 12.9173ZM6.66667 10.834V15.0007H11.25C11.8025 15.0007 12.3324 14.7812 12.7231 14.3905C13.1138 13.9998 13.3333 13.4699 13.3333 12.9173C13.3333 12.3648 13.1138 11.8349 12.7231 11.4442C12.3324 11.0535 11.8025 10.834 11.25 10.834H6.66667Z"
        fill={color || '#666666'}
        stroke={color || '#666666'}
        strokeWidth="0.5"
      />
    </svg>
  )
}

export const EditorTextItalic = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4987 16.6673H5.83203V15.0007H8.2712L10.0345 5.00065H7.4987V3.33398H14.1654V5.00065H11.7262L9.96286 15.0007H12.4987V16.6673Z"
        fill={color || '#666666'}
      />
    </svg>
  )
}

export const EditorTextUnderline = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66536 2.5V10C6.66536 10.8841 7.01655 11.7319 7.64167 12.357C8.2668 12.9821 9.11464 13.3333 9.9987 13.3333C10.8828 13.3333 11.7306 12.9821 12.3557 12.357C12.9808 11.7319 13.332 10.8841 13.332 10V2.5H14.9987V10C14.9987 11.3261 14.4719 12.5979 13.5342 13.5355C12.5965 14.4732 11.3248 15 9.9987 15C8.67262 15 7.40085 14.4732 6.46316 13.5355C5.52548 12.5979 4.9987 11.3261 4.9987 10V2.5H6.66536ZM3.33203 16.6667H16.6654V18.3333H3.33203V16.6667Z"
        fill={color || '#666666'}
      />
    </svg>
  )
}

export const EditorTextColor = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8327 4.99967V17.4997H9.16602V4.99967H4.16602V3.33301H15.8327V4.99967H10.8327Z"
        fill={color || '#333333'}
      />
      <rect
        x="13.334"
        y="12.2227"
        width="4.44445"
        height="4.44444"
        rx="2"
        fill={color || '#333333'}
      />
    </svg>
  )
}

export const TextAlignLeft = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 3.33301H17.5V4.99967H2.5V3.33301ZM2.5 15.833H14.1667V17.4997H2.5V15.833ZM2.5 11.6663H17.5V13.333H2.5V11.6663ZM2.5 7.49967H14.1667V9.16634H2.5V7.49967Z"
        fill={color || '#333333'}
      />
    </svg>
  )
}

export const TextAlignCenter = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 3.33301H17.5V4.99967H2.5V3.33301ZM4.16667 15.833H15.8333V17.4997H4.16667V15.833ZM2.5 11.6663H17.5V13.333H2.5V11.6663ZM4.16667 7.49967H15.8333V9.16634H4.16667V7.49967Z"
        fill={color || '#333333'}
      />
    </svg>
  )
}

export const TextAlignRight = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 3.33301H17.5V4.99967H2.5V3.33301ZM5.83333 15.833H17.5V17.4997H5.83333V15.833ZM2.5 11.6663H17.5V13.333H2.5V11.6663ZM5.83333 7.49967H17.5V9.16634H5.83333V7.49967Z"
        fill={color || '#333333'}
      />
    </svg>
  )
}

export const TextAlignJustify = ({ color }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 3.33301H17.5V4.99967H2.5V3.33301ZM2.5 15.833H17.5V17.4997H2.5V15.833ZM2.5 11.6663H17.5V13.333H2.5V11.6663ZM2.5 7.49967H17.5V9.16634H2.5V7.49967Z"
        fill={color || '#333333'}
      />
    </svg>
  )
}

export const ImageOutline = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.02464 18L4.00797 18.0167L3.99047 18H2.49464C2.27531 17.9998 2.06505 17.9125 1.91004 17.7573C1.75504 17.6022 1.66797 17.3918 1.66797 17.1725V3.8275C1.66949 3.60865 1.75705 3.39918 1.91173 3.24435C2.06641 3.08951 2.27579 3.00175 2.49464 3H17.508C17.9646 3 18.3346 3.37083 18.3346 3.8275V17.1725C18.3331 17.3914 18.2456 17.6008 18.0909 17.7557C17.9362 17.9105 17.7268 17.9983 17.508 18H4.02464ZM16.668 13V4.66667H3.33464V16.3333L11.668 8L16.668 13ZM16.668 15.3567L11.668 10.3567L5.6913 16.3333H16.668V15.3567ZM6.66797 9.66667C6.22594 9.66667 5.80202 9.49107 5.48946 9.17851C5.1769 8.86595 5.0013 8.44203 5.0013 8C5.0013 7.55797 5.1769 7.13405 5.48946 6.82149C5.80202 6.50893 6.22594 6.33333 6.66797 6.33333C7.11 6.33333 7.53392 6.50893 7.84648 6.82149C8.15904 7.13405 8.33464 7.55797 8.33464 8C8.33464 8.44203 8.15904 8.86595 7.84648 9.17851C7.53392 9.49107 7.11 9.66667 6.66797 9.66667Z"
        fill="#aaaaaa"
      />
    </svg>
  )
}
export const VoteOutline = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 3H16.6667C16.8877 3 17.0996 3.0878 17.2559 3.24408C17.4122 3.40036 17.5 3.61232 17.5 3.83333V17.1667C17.5 17.3877 17.4122 17.5996 17.2559 17.7559C17.0996 17.9122 16.8877 18 16.6667 18H3.33333C3.11232 18 2.90036 17.9122 2.74408 17.7559C2.5878 17.5996 2.5 17.3877 2.5 17.1667V3.83333C2.5 3.61232 2.5878 3.40036 2.74408 3.24408C2.90036 3.0878 3.11232 3 3.33333 3ZM4.16667 4.66667V16.3333H15.8333V4.66667H4.16667ZM9.16917 13.8333L5.63333 10.2975L6.81167 9.11917L9.16917 11.4767L13.8825 6.7625L15.0617 7.94083L9.16917 13.8333Z"
        fill="currentColor"
      />
    </svg>
  )
}
